import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

/**
 * Reusable circle (circolo) card.
 */
const CircleCard = ({ name, location, description, members, events, image, link = '/circolo' }) => {
  return (
    <Link to={link} className="card circle-card animate-on-scroll fade-up">
      <div className="circle-card__img" style={{ height: '140px', overflow: 'hidden', borderRadius: 'var(--radius-md) var(--radius-md) 0 0', margin: 'calc(var(--space-4) * -1) calc(var(--space-4) * -1) var(--space-4)', position: 'relative' }}>
        {image ? (
          <img src={image} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ 
            width: '100%', 
            height: '100%', 
            background: 'linear-gradient(135deg, var(--color-primary) 0%, #991b1b 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'rgba(255,255,255,0.2)'
          }}>
            <Icon name="Users" size={64} />
          </div>
        )}
      </div>
      <div className="circle-card__header">
        <div className="circle-card__icon"><Icon name="MapPin" size={20} /></div>
        <div>
          <div className="circle-card__name">{name}</div>
          <div className="circle-card__location">{location}</div>
        </div>
      </div>
      {description && (
        <p className="circle-card__desc line-clamp-2">{description}</p>
      )}
      <div className="circle-card__stats">
        {members && <span><Icon name="Users" size={14} style={{ marginRight: 4 }} /> {members} iscritti</span>}
        {events && <span><Icon name="Calendar" size={14} style={{ marginRight: 4 }} /> {events} eventi</span>}
      </div>
    </Link>
  );
};

export default CircleCard;
